<template>
    <loPage>
        <loSection>
            <loArticle>
                <mdFace
                    classStr="is-bad"
                >
                    <span>{{ $t('site.status.dataUndefined') }}</span>
                </mdFace>
            </loArticle>
        </loSection>
    </loPage>
</template>

<script>
    import loPage from '@/components/loPage'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import mdFace from '@/components/mdFace'

    export default {
        components: {
            loPage,
            loSection,
            loArticle,
            mdFace,
        },
    }
</script>

<style scoped lang="scss">

</style>
